import styled from "styled-components";
import compactSidebarCards from "./sidebarCardsCompact";

/*
  Sidebar derecho del editor de campaña (mismo comportamiento que el izquierdo,
  ver leftSideStyle.js). El botón "Continuar" se vuelve fijo abajo en < 1200px.
*/
const RightSideStyleHolder = styled.div`
    position: relative;
    padding-top: 25px;
    height: 100%;

    .rightSideContainer {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }

    .rightSideCards {
        display: flex;
        flex-direction: column;
        gap: 12px;
        min-width: 0;
    }

    .rightSideCards > *:empty {
        display: none;
    }

    @media only screen and (min-width: 768px) and (max-width: 1199px) {
        padding-top: 10px;
    }

    .rightSideCards {
        ${compactSidebarCards}
    }

    @media only screen and (max-width: 767px) {
        padding-top: 10px;
    }
    @media only screen and (max-width: 575px) {
        padding-top: 0;
        height: auto;
    }
`;

export default RightSideStyleHolder;
